import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { UniqueConnectorFlow } from "@/features/CouponCodes/Connector/StepFlow";
import { CONNECTOR_PLATFORMS } from "@/features/CouponCodes/connectorPlatforms";

const searchSchema = z.object({
  discountName: z.string().min(1),
});

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/new/unique/foxy",
)({
  validateSearch: zodValidator(searchSchema),
  component: UniqueFoxyRoute,
});

function UniqueFoxyRoute() {
  const { siteId } = Route.useParams();
  const { discountName } = Route.useSearch();
  const navigate = useNavigate();

  const handleClose = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes",
      params: { siteId },
    });
  };

  const handleBack = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes/new/unique",
      params: { siteId },
      search: { discountName },
    });
  };

  return (
    <UniqueConnectorFlow
      siteId={siteId}
      discountName={discountName}
      platform={CONNECTOR_PLATFORMS.foxy}
      onClose={handleClose}
      onBack={handleBack}
    />
  );
}
